// src/api/bannerApi.js
// -----------------------------------------------------------------------
// Fetches homepage slider/banner data from the backend (api/banners.php)
// -----------------------------------------------------------------------

const BASE_URL = "https://assocham.org/assocham_backend";

export async function fetchBanners() {
  const res = await fetch(`${BASE_URL}/api/banners.php`);

  if (!res.ok) {
    throw new Error(`Failed to fetch banners: ${res.status}`);
  }

  const json = await res.json();

  if (!json.success) {
    throw new Error(json.message || "Failed to fetch banners");
  }

  // json.data => [{ image, title, description, link }, ...]
  return json.data;
}